import React from 'react';
import { Row, Stack } from 'library/ui';

export function MainContainer({ children }: { children: React.ReactNode }) {
    return (
        <Stack align="center" padding="lg">
            <Stack maxWidth="sm" gap="md" align="center" fullWidth>
                {children}
            </Stack>
        </Stack>
    );
}

export function TextContainer({ children }: { children: React.ReactNode }) {
    return (
        <Stack gap="sm" align="center" fullWidth>
            {children}
        </Stack>
    );
}

export function ButtonContainer({ children }: { children: React.ReactNode }) {
    return (
        <Row gap="md" justify="center" wrap>
            {children}
        </Row>
    );
}

export function ImgContainer({ children }: { children: React.ReactNode }) {
    return <Row justify="center">{children}</Row>;
}
